export enum LocalStoreKey {
  LANG = 'autenti:templates:language',
  DEFAULT_LANG = 'autenti:templates:language:default',
}

export const AUTENTI_CONFIG_KEY = 'autentiConfig';
export const AUTENTI_CONFIG_URL = 'assets/config.json';
